import CreditCardPaymentButton from "@/components/paymentMethods/creditCard/CreditCardPaymentButton";
import type { PaymentFooterProps, GameData } from "@/interfaces";
import { useStyleTheme } from "@/hooks/useStyleTheme";

const PaymentFooter = ({
  isLoading,
  selectedCardId,
  handleCardPayClick,
  savedCards,
  onAddNewCard,
  gameData,
}: PaymentFooterProps & { gameData?: GameData }) => {
  // Filter out PayPal methods to check if there are actual credit cards
  const creditCardsOnly = savedCards?.filter(card => !card.id.startsWith('paypal_vaulted_')) || [];
  const theme = useStyleTheme(gameData);
  
  return (
    <div className="flex flex-col gap-2 mt-auto mx-5">
      {selectedCardId ? (
        <div className="md:mb-0 landscape:mb-0">
          <CreditCardPaymentButton
            isLoading={isLoading}
            isDisabled={isLoading}
            onClick={handleCardPayClick}
            theme={theme}
          />
        </div>
      ) : creditCardsOnly.length === 0 && onAddNewCard ? (
        <div className="md:mb-0 landscape:mb-0">
          <CreditCardPaymentButton
            placeHolder="Add A New Card"
            isLoading={isLoading}
            isDisabled={isLoading}
            onClick={onAddNewCard}
            theme={theme}
          />
        </div>
      ) : (
        // Show disabled Pay button when there are credit cards but none selected
        <div className="md:mb-0 landscape:mb-0">
          <CreditCardPaymentButton
            isLoading={isLoading}
            isDisabled={true}
            onClick={handleCardPayClick}
            theme={theme}
          />
        </div>
      )}
    </div>
  );
};

export default PaymentFooter;
